export const TextAndMedia = (() => {
	'use strict';

	function init() {

		var $image_toggles = $('.image-preview');
		var $images = $('.image-viewer .preview');

		$image_toggles.on('click', function(event) {
			
			event.preventDefault();
			var href = $(this).attr('href');

			// reset + activate
			$images.fadeOut(500);
			$(href).fadeIn(500);
			
			$image_toggles.removeClass('image-preview--active');
			$(this).addClass('image-preview--active');

		});

		$('.image-preview').eq(0).trigger('click');
	}

	return {
		init: init,
		name: 'text-and-media'
	};
})();
